"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("@/utils/gridReport/grhtml5-6.7-min");
var _grwebapp = require("@/utils/gridReport/grwebapp");
var _request = _interopRequireDefault(require("@/utils/request"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  data: function data() {
    return {
      tipTxt: '',
      templateJsonStr: ''
    };
  },
  props: {
    print: {
      type: Object,
      require: false,
      default: function _default() {
        return {
          name: '打印'
        };
      } // el-icon-document-add
    },
    dataUrl: {
      type: String,
      require: false
    },
    // 数据请求url
    data: {
      type: Object,
      require: false,
      default: function _default() {
        return {
          list: [{
            a: 1,
            b: 2
          }, {
            a: 1,
            b: 2
          }]
        };
      }
    },
    templateKey: {
      type: String,
      require: true
    },
    // 模板key
    model: {
      type: String,
      default: '' // 空 默认为打印预览 print/打印  pdf/生成pdf
    },
    // 数据请求url
    beforePrint: Function,
    showGrid: {
      type: Boolean,
      default: false
    } // 是否显示表格
  },
  computed: {},
  methods: {
    tipClick: function tipClick(event) {
      if (event.target.nodeName === 'A' && event.target.className === 'start') {
        // 获取触发事件对象的属性
        // alert('start');
        (0, _grwebapp.webapp_urlprotocol_startup)();
      }
    },
    goPrint: function goPrint() {
      var _this = this;
      if (this.beforePrint) {
        var before = this.beforePrint(this.data);
        if (before instanceof Promise) {
          before.then(function (res) {
            _this.doPrint();
          });
        } else {
          if (before) {
            this.doPrint();
          }
        }
      } else {
        this.doPrint();
      }
    },
    doPrint: function doPrint() {
      var _this2 = this;
      var print = function print(data) {
        var args = {};
        if (_this2.model) {
          args.type = _this2.model;
        }
        args.scripts = [{
          event: 'Initialize'
        }];
        // //也可以直接加载HTML5报表中已经载入的数据
        args.report = _this2.templateJsonStr;
        args.data = data || _this2.data;
        (0, _grwebapp.webapp_ws_ajax_run)(args, function (nodes) {
          _this2.tipTxt = nodes.innerHTML;
        });
      };
      if (this.dataUrl) {
        (0, _request.default)({
          url: this.dataUrl,
          method: 'get'
        }).then(function (res) {
          if (res.data) {
            print(res.data);
          }
        });
      } else {
        print();
      }
    },
    loadData: function loadData() {
      var _this3 = this;
      (0, _request.default)({
        url: '/mdg/mdg/template-manage/getByKey?templateKey=' + this.templateKey,
        method: 'get'
      }).then(function (res) {
        if (res.data) {
          if (!res.data.templateJsonStr) {
            alert('IcePrint打印组件加载模板失败');
            return;
          }
          _this3.templateJsonStr = res.data.templateJsonStr.replace('﻿{', '{');
          var reportViewer = window.rubylong.grhtml5.insertReportViewer('report_holder', _this3.templateJsonStr, _this3.data);
          window.reportViewer = reportViewer;
          if (_this3.showGrid) {
            reportViewer.start(); // 启动报表运行，生成报表，
          }
          var webSocket = new WebSocket('ws://127.0.0.1:22333');
          webSocket.onopen = function () {
            webSocket.close();
            webSocket = null;
          };
          webSocket.onerror = function () {
            (0, _grwebapp.webapp_urlprotocol_startup)();
          };
        }
      });
    }
  },
  watch: {},
  mounted: function mounted() {
    this.loadData();
  }
};